import { Routes } from '@angular/router';
import { authGuard, writeAccessGuard } from '../services/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/portal', pathMatch: 'full' },
  {
    path: 'portal',
    loadChildren: () => import('./pages/portal/portal.routes'),
    canActivate: [authGuard, writeAccessGuard],
  },
  {
    path: 'data-quality',
    loadChildren: () => import('./pages/data-quality/data-quality.routes'),
    canActivate: [authGuard, writeAccessGuard],
  },
  {
    path: 'transformer-analytics',
    loadChildren: () => import('./pages/transformer-analytics/transformer-analytics.routes'),
    canActivate: [authGuard, writeAccessGuard],
  },
  {
    path: 'dad',
    loadChildren: () => import('./pages/dad/dad.routes'),
    canActivate: [authGuard, writeAccessGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.DashboardComponent),
    canActivate: [authGuard, writeAccessGuard],
  },
  {
    path: 'cost-optimizer',
    loadChildren: () => import('./pages/cost-optimizer/cost-optimizer.routes'),
    canActivate: [authGuard, writeAccessGuard],
  },
  {
    path: 'admin',
    canActivate: [authGuard, writeAccessGuard],
    loadComponent: () =>
      import('./pages/admin/admin-layout').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/admin/admin').then(m => m.AdminComponent),
      },
      {
        path: 'documentation',
        loadComponent: () =>
          import('./pages/admin/documentation/documentation').then(m => m.DocumentationComponent),
      },
      {
        path: 'tech-ref',
        loadComponent: () =>
          import('./pages/admin/tech-ref/tech-ref').then(m => m.TechRefComponent),
      },
      {
        path: 'asset-annually',
        loadComponent: () =>
          import('./pages/admin/asset-annually/asset-annually').then(m => m.AssetAnnuallyComponent),
      },
      {
        path: 'chatbot',
        loadComponent: () =>
          import('./pages/admin/chatbot/chatbot').then(m => m.ChatbotComponent),
      },
      {
        path: 'upload-knowledge',
        loadComponent: () =>
          import('./pages/admin/upload-knowledge/upload-knowledge').then(m => m.UploadKnowledgeComponent),
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./pages/unauthorized/unauthorized').then(m => m.UnauthorizedComponent),
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '/portal' },
];
